<script setup lang="ts">
import MenuLink from '@app/layout/nav/mobile/components/MenuLink.vue';
import Icon from '@components/Icon.vue';
import { URL_SUBSCRIPTION, URL_USER_INBOX, URL_USER_OFFERS } from '@tools/routes/routes';
import IconEnvelope from '@icons/ph_envelope.svg';
import IconTag from '@icons/ph_tag.svg';
import IconReceip from '@icons/ph_receip.svg';
import { trans } from '@tools/translation.ts';
</script>

<template>
  <li>
    <MenuLink :link="URL_USER_INBOX">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconEnvelope"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.inbox') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink :link="URL_USER_OFFERS">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconTag"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.offers') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink :link="URL_SUBSCRIPTION">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconReceip"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.subscriptions') }}
      </template>
    </MenuLink>
  </li>
</template>
